import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiResponse } from "@shared/models/api-response";
import { Standard } from "@shared/models/standard";
import { environment } from "environments/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class PonderationService {

  private baseUrl = environment.vibrationApiURL;

  constructor(private httpClient: HttpClient) { }
    public getPonderation(siteId: number,controlPointId: number): Observable<ApiResponse<any>> {
    let params = new HttpParams();
    if(siteId != null) {
      params = params.append('siteId',siteId);
    }
    if(controlPointId != null) {
      params = params.append('controlPointId', controlPointId);
    }
    return this.httpClient.get<ApiResponse<any>>(`${this.baseUrl}/ponderation`, { params });
  }
    updateSitePonderation(siteId: number, ponderationId: number | null, standardCode?: string | null): Observable<any> {
    let params = new HttpParams();
    if (ponderationId !== null && ponderationId !== undefined) {
      params = params.set('ponderationId', ponderationId);
    }
    if (standardCode) {
      params = params.set('standardCode', standardCode);
    }
    return this.httpClient.put<any>(`${this.baseUrl}/ponderation/site/${siteId}`, {}, { params });
    }
updateControlPointPonderation(controlPointId: number, ponderationId: number | null, standardCode?: string | null): Observable<any> {
    let params = new HttpParams();
    if (ponderationId !== null && ponderationId !== undefined) {
      params = params.set('ponderationId', ponderationId);
    }
    if (standardCode) {
      params = params.set('standardCode', standardCode);
    }
    return this.httpClient.put<any>(`${this.baseUrl}/ponderation/control-point/${controlPointId}`, {}, { params });
}
    public getAllPonderations(): Observable<ApiResponse<any[]>> {
        return this.httpClient.get<ApiResponse<string[]>>(`${this.baseUrl}/ponderation/all`);
  }

  public getAllStandards(): Observable<ApiResponse<Standard[]>> {
    return this.httpClient.get<ApiResponse<Standard[]>>(`${this.baseUrl}/ponderation/standards`);
  }

  public getStandardCodeBySiteId(siteId: number): Observable<ApiResponse<string | null>> {
    return this.httpClient.get<ApiResponse<string | null>>(`${this.baseUrl}/ponderation/site/${siteId}/standard-code`);
  }
}